import React from 'react'

import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
  Grid,
} from '@material-ui/core'

import {
  HashRouter as Router,
  withRouter,
  RouteComponentProps,
} from 'react-router-dom'

import { AppContextProvider, AppContext } from './contexts/AppContext'

import { Loading } from '@elgatoylacaja/components'

import {
  useLoader,
  useWindowSize,
  LoadingProvider,
  useScrollTop,
} from '@elgatoylacaja/hooks'

import { analyticsUtils } from '@elgatoylacaja/utils'

import SwitchRoutes from './LazySwitchRoutes'

import SITUATIONS_IMG from './logo_situations.png'
import TedxLogo from './tedx_logo.png'
import GatoLogo from './logo_gato_texto.png'

import { useTranslation } from 'react-i18next'

const styles = (theme: Theme) =>
  createStyles({
    app: {
      textAlign: 'center',
      maxWidth: '800px',
      width: '100%',
      margin: '0 auto',
      padding: '0',
      minHeight: '100vh',
    },
    container: {
      padding: 24,
      paddingTop: 0,
      position: 'relative',
      width: '800px',
      '@media only screen and (max-width : 800px)': {
        width: '100%',
      },
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    labs: {
      display: 'block',
      width: '250px',
      margin: '30px auto',
      '@media only screen and (max-width : 800px)': {
        display: 'none',
      },
    },
  })

const Analytics = withRouter((props: RouteComponentProps) => {
  const [visited, setVisited] = React.useState<string[]>([])
  const { pathname } = props.location
  const { origin, pathname: windowPathname } = window.location

  const { i18n } = useTranslation()

  React.useEffect(() => {
    if (!visited.includes(pathname)) {
      analyticsUtils.REGISTER_VISIT(`${origin}${windowPathname}#${pathname}`)
      setVisited(paths => [...paths, pathname])
    }
  }, [pathname, visited, origin, windowPathname])

  React.useEffect(() => {
    if (pathname === '/terms') {
      analyticsUtils.EVENT({
        action: `Visit (terms) language ${i18n.language}`,
        category: 'Language Visit/Left',
      })
    }
  }, [pathname, i18n.language])

  React.useEffect(() => {
    window.onbeforeunload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      analyticsUtils.EVENT({
        action: `Left language ${i18n.language}`,
        category: 'Language Visit/Left',
        label: `${origin}${windowPathname}#${pathname}`,
      })
      analyticsUtils.REGISTER_LEFT(`${origin}${windowPathname}#${pathname}`)
    }
  }, [pathname, origin, windowPathname, i18n.language])

  const [shareAnalytics, setShareAnalytics] = React.useState(false)

  React.useEffect(() => {
    if (!shareAnalytics) {
      const search = props.location.search
      const params = new URLSearchParams(search)
      const share = params.get('share')
      const shareServices = ['facebook', 'twitter', 'whatsapp']
      if (share !== null && shareServices.includes(share)) {
        analyticsUtils.VISIT_BY_SHARE(
          share as 'whatsapp' | 'twitter' | 'facebook'
        )
        setShareAnalytics(true)
      }
    }
  }, [shareAnalytics, props.location.search])

  return <></>
})

const Loader = () => {
  const { loading } = useLoader()
  return <Loading fixed loading={loading} />
}

// const LanguageDetector = withRouter((props: RouteComponentProps) => {
//   // const { startLoading, stopLoading } = useLoader()
//   const { i18n } = useTranslation()
//   // const es_en_language = (lang: string) => (lang.includes('es') ? 'es' : 'en')

//   i18n.changeLanguage('es')

//   // const [settedDefaultLang, setSettedDefaultLang] = React.useState(false)

//   // React.useEffect(() => {
//   //   if (!settedDefaultLang) {
//   //     const search = props.location.search
//   //     const params = new URLSearchParams(search)
//   //     const urlParamLanguage = params.get('language')
//   //     if (urlParamLanguage !== null) {
//   //       dispatch({
//   //         type: 'SET_LANGUAGE',
//   //         language: es_en_language(urlParamLanguage),
//   //       })
//   //     } else {
//   //       startLoading()
//   //       if (!language.includes('es')) {
//   //         fetch(`https://ipapi.co/json`)
//   //           .then(res => res.json())
//   //           .then(data => {
//   //             const locLang = data.languages.split(',')[0].split('-')[0]
//   //             dispatch({
//   //               type: 'SET_LANGUAGE',
//   //               language:
//   //                 data.country_name === 'Argentina'
//   //                   ? 'es'
//   //                   : es_en_language(locLang),
//   //             })
//   //           })
//   //           .catch(error => {
//   //             dispatch({
//   //               type: 'SET_LANGUAGE',
//   //               language: es_en_language(navigator.language),
//   //             })
//   //           })
//   //           .finally(() => {
//   //             stopLoading()
//   //           })
//   //       } else {
//   //         dispatch({
//   //           type: 'SET_LANGUAGE',
//   //           language: es_en_language(navigator.language),
//   //         })
//   //         stopLoading()
//   //       }
//   //     }
//   //     setSettedDefaultLang(true)
//   //   }
//   // }, [
//   //   props.location.search,
//   //   dispatch,
//   //   startLoading,
//   //   stopLoading,
//   //   language,
//   //   settedDefaultLang,
//   // ])

//   return (
//     <>
//       <meta property="og:title" content="Dilemas de la pandemia" />
//       <meta
//         property="og:description"
//         content="Ayudanos a entender cómo tomamos decisiones morales durante la pandemia."
//       />
//     </>
//   )

//   // return (
//   //   <>
//   //     {i18n.language.includes('es') ? (
//   //       <>
//   //         <meta property="og:title" content="Dilemas de la pandemia" />
//   //         <meta
//   //           property="og:description"
//   //           content="Ayudanos a entender cómo tomamos decisiones morales durante la pandemia."
//   //         />
//   //       </>
//   //     ) : (
//   //       <>
//   //         <meta property="og:title" content="Dilemmas during a pandemic" />
//   //         <meta
//   //           property="og:description"
//   //           content="Help us understand how we make moral decisions during the pandemic."
//   //         />
//   //       </>
//   //     )}
//   //   </>
//   // )
// })

const Container: React.FC<RouteComponentProps &
  WithStyles<typeof styles>> = props => {
  useScrollTop(props.location.pathname)

  const shouldShowTedxGato = React.useMemo(() => {
    return ['/terms', '/demo/terms'].includes(props.location.pathname)
  }, [props.location.pathname])

  const shouldShowSituationsLogo = React.useMemo(() => {
    return [
      '/intro',
      '/demo/intro',
      '/situations',
      '/demo/situations',
      '/oxford',
      '/demo/oxford',
      '/regressors',
      '/demo/regressors',
      '/done',
      '/demo/done',
      '/thanks',
      '/demo/thanks',
    ].includes(props.location.pathname)
  }, [props.location.pathname])

  const { height } = useWindowSize()

  const winHeight = height !== undefined ? `${height}px` : `100vh`

  const minHeight =
    shouldShowSituationsLogo || shouldShowTedxGato
      ? `calc(${winHeight} - 84px)`
      : `calc(${winHeight})`

  return (
    <>
      {shouldShowTedxGato ? (
        <div
          style={{
            display: 'flex',
            padding: '0 24px',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '84px',
            maxWidth: '400px',
            margin: 'auto',
          }}
        >
          <img
            src={TedxLogo}
            alt="Tedxperiment logo"
            style={{
              maxHeight: 33,
              maxWidth: '50%',
              display: 'block',
              paddingTop: '24px',
            }}
          />
          <span style={{ paddingTop: '24px' }}>+</span>
          <img
            src={GatoLogo}
            alt="Logo gato"
            style={{
              maxHeight: 40,
              maxWidth: '40%',
              display: 'block',
              paddingTop: '24px',
            }}
          />
        </div>
      ) : null}
      {shouldShowSituationsLogo ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '84px',
            margin: 'auto',
          }}
        >
          <img
            src={SITUATIONS_IMG}
            alt="Experiment logo"
            style={{ height: '50px', paddingTop: '24px' }}
          />
        </div>
      ) : null}
      <Grid container justify="center" style={{ minHeight }}>
        <Grid item className={props.classes.container} style={{ minHeight }}>
          {props.children}
        </Grid>
      </Grid>
    </>
  )
}

const FinalContainer = withRouter(Container)

const App = ({ classes }: WithStyles<typeof styles>) => {
  return (
    <div className={classes.app}>
      <AppContextProvider>
        <LoadingProvider>
          <Router hashType="slash">
            {/* <LanguageDetector /> */}
            {process.env.REACT_APP_ENVIRONMENT === 'production' && (
              <Analytics />
            )}
            <Loader />
            <FinalContainer classes={classes}>
              <SwitchRoutes />
            </FinalContainer>
          </Router>
        </LoadingProvider>
      </AppContextProvider>
    </div>
  )
}

export default withStyles(styles)(App)
